import React from 'react'

export default function Footer() {
  return (
    <footer className="border-t border-gray-200 bg-white">
      <div className="container mx-auto px-4">
        <div className="h-16 flex items-center justify-center">
          <p className="text-sm text-[#AFAFAF]">
            All rights reserved. © {new Date().getFullYear()}, <span className='text-[#080808] font-bold'>InfosecTrain (A Brand of AZPIRANTZ TECHNOLOGIES LLP)</span>
          </p>

        </div>
      </div>
    </footer>

  )
}
